import React from "react";
import UserMenu from "../UserMenu/UserMenu";
import "./AppLayout.css";
import logo from "../../assests/logo.png";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const AppLayout = ({ children, hideFamily = false, showBackBtn = false }) => {

  const navigate = useNavigate();

  return (
    <div className="app-layout">
      <header className="top-header" style={{margin:"20px"}}>
        <IoArrowBack className={`back-btn ${showBackBtn ? '' : 'hide'}`} onClick={() => navigate(-1)} />
        <img src={logo} style={{ width: '130px', height: '130px', objectFit: 'contain' }} alt="logo" className="logo" onClick={() => navigate('/')} />
        {/* <UserMenu hideFamily={hideFamily} /> */}
      </header>
      <main className="app-main">{children}</main>
    </div>
  );
};

export default AppLayout;
